/**
 * SlickController
 *
 * @author Manuel Müller <manuel.mueller@pluswerk.ag>
 */
Pluswerk.PlusProject.Image.SlickController = function () {
  var $imageGallery = $('.js-imageGallery-slider');
  var $contentSlider = $('.js-contentSlider');
  var $timelineNav = $('.js-timeline-nav-slider');
  var $timelineContent = $('.js-timeline-content-slider');
  var $timelineImages = $('.js-timeline-images-slider');
  var $highlightedFairs = $('.js-highlightedFairSlider');
  var $testimonialSlider = $('.js-testimonialSlider');
  var $testimonialSliderWrapper = $('.js-testimonialSliderWrapper');
  var $testimonialSliderProgress = $('.js-testimonialSliderProgress span');
  var time = 10;
  var isPause;
  var tick;
  var percentTime;
  var dir = $html.attr('dir');

  var isDirectionRtl = function () {
    return dir === 'rtl';
  };

  if ($('.sponsorWrapper--hasSecond:not(.sponsorWrapper--hasSecond-1)').length ||  $('.sponsorWrapper--hasFirst:not(.sponsorWrapper--hasFirst-1)').length) {
    // if only one slider exists, target the one
    $('.sponsorWrapper--hasFirst:not(.sponsorWrapper--hasSecond) .js-sponsor-slider, .sponsorWrapper--hasSecond:not(.sponsorWrapper--hasFirst) .js-sponsor-slider').slick({
      infinite: true,
      speed: 500,
      autoplay: true,
      autoplaySpeed: 4000,
      slidesToShow: 7,
      slidesToScroll: 1,
      swipeToSlide: true,
      dots: false,
      arrows: true,
      prevArrow: '<button type="button" class="slick-prev icon icon-double-arrow-left">Previous</button>',
      nextArrow: '<button type="button" class="slick-next icon icon-double-arrow-right">Next</button>',
      rtl: isDirectionRtl(),
      responsive: [
        {
          breakpoint: 1920,
          settings: {
            slidesToShow: 6
          }
        },
        {
          breakpoint: 1680,
          settings: {
            slidesToShow: 5
          }
        },
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 450,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });

    // if both slider exist but both must have more than one slide, target both
    $('.sponsorWrapper--hasFirst:not(.sponsorWrapper--hasFirst-1).sponsorWrapper--hasSecond:not(.sponsorWrapper--hasSecond-1) .js-sponsor-slider, .sponsorWrapper--hasFirst.sponsorWrapper--hasFirst-1.sponsorWrapper--hasSecond.sponsorWrapper--hasSecond-1 .js-sponsor-slider').slick({
      infinite: true,
      speed: 500,
      autoplay: true,
      autoplaySpeed: 4000,
      slidesToShow: 4,
      slidesToScroll: 1,
      swipeToSlide: true,
      dots: false,
      arrows: true,
      prevArrow: '<button type="button" class="slick-prev icon icon-double-arrow-left">Previous</button>',
      nextArrow: '<button type="button" class="slick-next icon icon-double-arrow-right">Next</button>',
      rtl: isDirectionRtl(),
      responsive: [
        {
          breakpoint: 1920,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 1680,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 450,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });

    // if both slider exist but one must have only one slide, target the one with one slide
    $('.sponsorWrapper--hasFirst.sponsorWrapper--hasFirst-1.sponsorWrapper--hasSecond:not(.sponsorWrapper--hasSecond-1) .sponsors--first .js-sponsor-slider, .sponsorWrapper--hasFirst.sponsorWrapper--hasSecond.sponsorWrapper--hasSecond-1:not(.sponsorWrapper--hasFirst-1) .sponsors--second .js-sponsor-slider').slick({
      infinite: true,
      speed: 500,
      autoplay: true,
      autoplaySpeed: 4000,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipeToSlide: true,
      dots: false,
      arrows: true,
      prevArrow: '<button type="button" class="slick-prev icon icon-double-arrow-left">Previous</button>',
      nextArrow: '<button type="button" class="slick-next icon icon-double-arrow-right">Next</button>',
      rtl: isDirectionRtl(),
      responsive: [
        {
          breakpoint: 1441,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 450,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });


    // if both slider exist but one must have only one slide, target the one with many slides
    $('.sponsorWrapper--hasFirst.sponsorWrapper--hasFirst-1.sponsorWrapper--hasSecond .sponsors--second .js-sponsor-slider, .sponsorWrapper--hasFirst.sponsorWrapper--hasSecond.sponsorWrapper--hasSecond-1 .sponsors--first .js-sponsor-slider').slick({
      infinite: true,
      speed: 500,
      autoplay: true,
      autoplaySpeed: 4000,
      slidesToShow: 4,
      slidesToScroll: 1,
      swipeToSlide: true,
      dots: false,
      arrows: true,
      prevArrow: '<button type="button" class="slick-prev icon icon-double-arrow-left">Previous</button>',
      nextArrow: '<button type="button" class="slick-next icon icon-double-arrow-right">Next</button>',
      rtl: isDirectionRtl(),
      responsive: [
        {
          breakpoint: 1920,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 1750,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1480,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 450,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }
  $highlightedFairs.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    autoplay: true,
    infinite: true,
    autoplaySpeed: 8000,
    cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
    prevArrow: '<button type="button" class="slick-prev icon icon-arrow-left">Previous</button>',
    nextArrow: '<button type="button" class="slick-next icon icon-arrow-right">Next</button>',
    rtl: isDirectionRtl()
  });

  $timelineNav.slick({
    accessibility: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    centerMode: false,
    arrows: true,
    dots: false,
    infinite: false,
    focusOnSelect: true,
    swipeToSlide: true,
    asNavFor: '.js-timeline-content-slider',
    cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
    prevArrow: '<button type="button" class="slick-prev icon icon-arrow-left">Previous</button>',
    nextArrow: '<button type="button" class="slick-next icon icon-arrow-right">Next</button>',
    rtl: isDirectionRtl(),
    responsive: [
      {
        breakpoint: 3000,
        settings: {
          slidesToShow: 7
        }
      },
      {
        breakpoint: 1680,
        settings: {
          slidesToShow: 6
        }
      },
      {
        breakpoint: 1480,
        settings: {
          slidesToShow: 5
        }
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 680,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  $timelineContent.slick({
    accessibility: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: false,
    swipe: false,
    asNavFor: '.js-timeline-nav-slider',
    cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
    prevArrow: '<button type="button" class="slick-prev icon icon-arrow-left">Previous</button>',
    nextArrow: '<button type="button" class="slick-next icon icon-arrow-right">Next</button>',
    rtl: isDirectionRtl()
  });

  $timelineImages.slick({
    accessibility: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    swipe: true,
    swipeToSlide: false,
    infinite: false,
    cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
    prevArrow: '<button type="button" class="slick-prev icon icon-arrow-left">Previous</button>',
    nextArrow: '<button type="button" class="slick-next icon icon-arrow-right">Next</button>',
    rtl: isDirectionRtl()
  });

  $imageGallery.each(function () {
    $(this).slick({
      lazyLoad: 'progressive',
      infinite: false,
      variableWidth: true,
      draggable: false,
      slidesToScroll: 1,
      cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
      arrows: true,
      appendArrows: $(this).parent().find('.js-imageGallery-nav'),
      prevArrow: '<button type="button" class="slick-prev icon icon-double-arrow-left">Previous</button>',
      dots: true,
      appendDots: $(this).parent().find('.js-imageGallery-nav'),
      nextArrow: '<button type="button" class="slick-next icon icon-double-arrow-right">Next</button>',
      rtl: isDirectionRtl(),
    });
  });

  $contentSlider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    adaptiveHeight: true,
    cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
    appendArrows: '.js-contentSlider-nav',
    prevArrow: '<button type="button" class="slick-prev icon icon-arrow-left">Previous</button>',
    nextArrow: '<button type="button" class="slick-next icon icon-arrow-right">Next</button>',
    rtl: isDirectionRtl()
  });

  $testimonialSlider.each(function () {
    var $individual = $(this);

    $individual.on('init', function (event, slick) {
      if (slick.slideCount <= 1) {
        $(this).parent().find('.testimonialSlider__progress').addClass('hide');
        $(this).find('.slick-dots').addClass('hide');
      }
    });

    $individual.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      speed: 760,
      infinite: true,
      arrows: false,
      dots: true,
      autoplay: true,
      autoplaySpeed: time * 1000,
      pauseOnDotsHover: true,
      adaptiveHeight: true,
      prevArrow: '<button type="button" class="slick-prev icon icon-arrow-left">Previous</button>',
      nextArrow: '<button type="button" class="slick-next icon icon-arrow-right">Next</button>',
      rtl: isDirectionRtl()
    });

    $individual.on('beforeChange', function () {
      startProgressbar();
    });
  });

  // @TODO enable multiple testimonial slider on one page, currently they kinda change slides together
  $testimonialSliderWrapper.on({
    mouseenter: function () {
      isPause = true;
    },
    mouseleave: function () {
      isPause = false;
    }
  });

  function startProgressbar() {
    resetProgressbar();
    percentTime = 0;
    isPause = false;
    tick = setInterval(interval, 10);
  }

  function interval() {
    if (isPause === false) {
      percentTime += 1 / (time + 0.1);
      $testimonialSliderProgress.css({
        width: percentTime + '%'
      });

      if (percentTime >= 100) {
        $testimonialSlider.slick('slickNext');
        startProgressbar();
      }
    }
  }

  function resetProgressbar() {
    $testimonialSliderProgress.css({
      width: 0 + '%'
    });
    clearTimeout(tick);
  }

  startProgressbar();
};
